/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import secureLocalStorage from 'react-secure-storage';
const Stripe = ({ Amount }) => {

    const { BaseUrl, setPaymentRes, setTransactionId, setPaymentLod } = useContext(MyContext);

    const [cardNumber, setCardnumber] = useState();
    const [expiry, setExpiry] = useState('');
    const [cvc, setCvc] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setPaymentLod(false);
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (loading) {
            showTost("Payment in Process !!", "info");
            return;
        }


        if (!cardNumber && !expiry && !cvc) {
            showTost("Enter Payment Details !!", "error");
            return;
        }

        setLoading(true);

        const number = cardNumber.replace(/\s+/g, '');
        const month = expiry.split("/")[0];
        const year = expiry.split("/")[1];

        const currentYear = new Date().getFullYear();
        const currentYearLastTwoDigits = currentYear.toString().slice(-2);

        const loginuser = secureLocalStorage.getItem("LoginData");

        if (loginuser) {
            const UserDetails = JSON.parse(loginuser);

            axios.post(`${BaseUrl}react_stripe/token.php`,
                {
                    "card_number": number,
                    "exp_month": month,
                    "exp_year": `${currentYearLastTwoDigits}${year.slice(2)}`,
                    "cvc": cvc,
                    "custName": UserDetails.name,
                    "custEmail": UserDetails.email,
                    "amount": Amount
                }
            )
                .then((res) => {
                    console.log(res);

                    if (res.data.Result === "true") {
                        setPaymentRes("PaymentDone");
                        setTransactionId(res.data.Transaction_id);
                    } else {
                        setPaymentRes("PaymentFaild");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.log("react_stripe/token.php", error);
                });
        }
    };


    const handleCardNumberChange = (e) => {
        let value = e.target.value;
        const cleanedValue = value.replace(/\D/g, '');
        const formattedValue = cleanedValue.replace(/(\d{4})(?=\d)/g, '$1 ');
        setCardnumber(formattedValue);
    };

    const handleExpiryChange = (e) => {
        const value = e.target.value;
        const cleanedValue = value.replace(/\D/g, '');
        const formattedValue = cleanedValue.replace(/(\d{2})(?=\d)/g, '$1/');
        setExpiry(formattedValue);
    };


    return (
        <form onSubmit={handleSubmit} className="DemoWrapper w-[100%] text-start">
            <label className=''>
                <span className='text-[18px] font-[500]'>Card number</span> <br />
                <input
                    type="text"
                    placeholder="1234 1234 1234 1234"
                    value={cardNumber}
                    onChange={handleCardNumberChange}
                    maxLength="19"
                    className='border-[2px] w-[100%] focus-within:border-[#0000ffb7] outline-none py-[3px] px-[5px] rounded-[5px] mt-[5px]'
                />
            </label>
            <div className="flex justify-between items-center mt-[10px]">
                <label className='w-[40%] text-start'>
                    <span className='text-[18px] font-[500]' >Expiration date</span>
                    <input
                        type="text"
                        placeholder="MM/YY"
                        value={expiry}
                        onChange={handleExpiryChange}
                        maxLength="5"
                        className='border-[2px] w-[100%] outline-none py-[3px] px-[5px] rounded-[5px] mt-[5px] focus-within:border-[#0000ffb7]'
                    />
                </label>
                <label className='w-[40%] text-start'>
                    <span className='text-[18px] font-[500] ' >CVC</span>
                    <input type='number' onChange={(e) => setCvc(e.target.value)} placeholder='CVC' className='border-[2px] focus-within:border-[#0000ffb7] w-[100%] outline-none py-[3px] px-[5px] rounded-[5px] mt-[5px]' />
                </label>
            </div>
            <button type="submit" className='button'>
                {loading ? <span className="loader2 -mb-[7px]"></span> : "Pay" + Amount ? `$${Amount}` : ""}
            </button>
        </form>
    )
}

export default Stripe;
/* jshint ignore:end */